import { useContext } from 'react';
import { FlagContext } from '../FlagContext';
import { isFlagEnabled, isAnyFlagEnabled } from '../helpers';
export function useFlag(flag) {
    var flags = useContext(FlagContext);
    return isFlagEnabled(flags, flag);
}
export function useAnyFlag(flagSet) {
    var flags = useContext(FlagContext);
    return isAnyFlagEnabled(flags, flagSet);
}
//# sourceMappingURL=useFlag.js.map